const Symbols = {
    AnchorContext: Symbol('AnchorContext'),
    CheckboxContext: Symbol('CheckboxContext'),
    ConfigContext: Symbol('ConfigContext'),
    FormContext: Symbol('FormContext'),
    LayoutContext: Symbol('LayoutContext'),
    LayoutSiderContext: Symbol('LayoutSiderContext'),
    ListContext: Symbol('ListContext'),
    LocaleContext: Symbol('LocaleContext'),
    MenuContext: Symbol('MenuContext'),
    ModalContext: Symbol('ModalContext'),
    RadioContext: Symbol('RadioContext'),
    TabsContext: Symbol('TabsContext'),
    TreeContext: Symbol('TreeContext'),
    ProFormContext: Symbol('ProFormContext'),
    ProTableContext: Symbol('ProTableContext'),
    ProPerformanceTableContext: Symbol('ProPerformanceTableContext'),
};
export default Symbols;
